import { render } from "./Preferences.vue?vue&type=template&id=68238ccd&scoped=true"
import script from "./Preferences.vue?vue&type=script&lang=js"
export * from "./Preferences.vue?vue&type=script&lang=js"

import "./Preferences.vue?vue&type=style&index=0&id=68238ccd&lang=css"
import "./Preferences.vue?vue&type=style&index=1&id=68238ccd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68238ccd"]])

export default __exports__